export const typeHotline = [
    { id: 1, name: 'Show all' },
    { id: 2, name: 'Show in room' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeHotline.js